<template>
  <NSelect class="n-country" v-bind="attrs" :get-popup-container="node => node.parentNode" />
</template>

<script setup>
import {useBootstrap} from '@front/hooks';
import {computed, useAttrs, watch} from 'vue';

const props = defineProps({
  value: undefined,
  currency: undefined,
  country: undefined,
});

const emit = defineEmits(['update:value']);

const { ENUMS } = useBootstrap();

const attrs = computed(() => ({
  options: ebOptions.value,
  label: 'epaybankId',
  // ...useAttrs(),
  value: props.value,
  'onUpdate:value': v => emit('update:value', v),
}));


const ebOptions = computed(() => {
  return ENUMS.value.EpayBank?.filter(o => o.currency === props.currency && o.country == props.country);
});

watch(
  () => {},
  to => {
    if (props.value && !to.find(o => o.value === props.value)) {
      emit('update:value', null);
    }
  },
);
</script>

<script>
export default {
  name: 'NEpayBank',
};
</script>
